import { Box } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType, ContentPagePanelType, DefaultHandlerType, FrontPagePanelSize, ReportSharingType, ReportType, WhistleBlowAnonymity, WhistleBlowResolution, WhistleBlowSeverity, WhistleBlowSource, WhistleBlowState, WhistleBlowStateFilter } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { Translations } from "ui/Scripts/source/models/translations";
import { IWhistleBlowCategoryListItem } from "ui/Scripts/source/models/whistleBlowCategory/whistleBlowCategoryListItem";
import { AppUtils } from "source/framework/appUtils";
import { IChartItem } from "source/models/chart/chartItem";
import { ISavedChartPanel, SavedChartPanel } from "source/models/chart/savedChartPanel";
import { IListFilterItem, ListFilterItem } from "source/models/common/listFilterItem";
import { IPagePanel, PagePanel } from "source/models/common/pagePanel";
import { ISavedListFilter } from "source/models/common/savedListFilter";
import { ITypedOption } from "source/models/common/typedOption";
import { IReportItem, ReportItem } from "source/models/report/reportItem";
import { getStateChangeAfterChangeActiveReport, getStateChangeAfterChangeActiveSavedReport, handleRemoveSavedReport, ReportItems } from "source/models/report/reportItems";
import { ISavedReport } from "source/models/report/savedReport";
import { recordLockManager } from "source/models/services/recordLockService";
import * as whistleBlowService from "source/models/services/whistleBlowService";
import { IAppSessionState } from "source/models/store/storeTypes";
import { IUnitDefaultHandlersNode } from "source/models/unit/unitDefaultHandlersNode";
import { IUnitModuleNode } from "source/models/unit/unitModuleNode";
import { IUnitNodePermissions } from "source/models/unit/unitNodePermissions";
import { UserListItems } from "source/models/user/userListItems";
import { IWhistleBlowPage } from "source/models/whistleBlow/whistleBlowPage";
import { DashboardPanelList } from "source/components/app/DashboardPanelList";
import { HeaderMenuItem, NavigationMenu } from "source/components/app/NavigationMenu";
import { UserMenu } from "source/components/app/UserMenu";
import { SettingsButton } from "source/components/framework/Button/SettingsButton";
import { ListFilterSaveDialog } from "source/components/framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "source/components/framework/Page/PageContainer";
import { PageContent } from "source/components/framework/Page/PageContent";
import { PageDashboard } from "source/components/framework/Page/PageDashboard";
import { PageFilterConditionDrawer } from "source/components/framework/Page/PageFilterConditionDrawer";
import { PageListAndReportsContainer } from "source/components/framework/Page/PageListAndReportsContainer";
import { PageReportsContainer } from "source/components/framework/Page/PageReportsContainer";
import { PageTabs } from "source/components/framework/Page/PageTabs";
import { PageTitle } from "source/components/framework/Page/PageTitle";
import { PageTopBar } from "source/components/framework/Page/PageTopBar";
import { IPageNavMenuItem } from "source/components/framework/PageNav/PageNavMenuItems";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { ReportSettings } from "source/components/framework/ReportSettings";
import { PageNavMenuReportList } from "source/components/report/PageNavMenuItemReportList/PageNavMenuItemReportList";
import { ISaveReportFilters } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog";
import { SaveReportDialog } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog/SaveReportDialog";
import { WhistleBlowArchiveDialog } from "../WhistleBlowArchiveDialog";
import { WhistleBlowSettingsDialogMenuItem, WhistleBlowSettingsDialog } from "../WhistleBlowSettingsDialog";
import { WhistleBlowFilter } from "../WhistleBlowFilter";
import { WhistleBlowList } from "../WhistleBlowList";
import { IWhistleBlowPageFilterState, WhistleBlowPageDashboardChart } from "../WhistleBlowPageDashboardChart";
import { WhistleBlowReportFilterPanel } from "../WhistleBlowReportFilterPanel";
import { WhistleBlowReportList } from "../WhistleBlowReportList";
import { abortManager } from "source/models/services/tokenService";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { TDefaultListFilter } from "source/models/common/defaultListFilter";
import { RouteComponentProps } from "react-router-dom";
import { IWhistleBlowListState, setWhistleBlowListDefaultFilter } from "source/models/store/whistleBlow";

/* eslint-disable no-unused-vars */
export const enum WhistleBlowPageViewTypeId {
    Records = "0",
    Reports = "1",
    Dashboard = "2",
}
/* eslint-enable no-unused-vars */

// WhistleBlowPage
export interface IWhistleBlowPageOwnProps {
}

export interface IWhistleBlowPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    whistleBlowPage: IWhistleBlowPage;
    list: IWhistleBlowListState;
}

export interface IWhistleBlowPageDispatchProps {
    onGetWhistleBlowPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

export interface IWhistleBlowPagePathProps {
    page: string;
}

type WhistleBlowPageProp = IWhistleBlowPageOwnProps & IWhistleBlowPageStateProps & IWhistleBlowPageDispatchProps & RouteComponentProps<IWhistleBlowPagePathProps>;

interface IWhistleBlowPageState extends IWhistleBlowPageFilterState {
    initialized: boolean;
    units: IIdTitleNode[];
    categories: IIdTitle[];
    handlers: IIdTitle[];
    stateFilters: IIdTitle[];
    severityFilters: IIdTitle[];
    resolutionFilters: IIdTitle[];
    sourceFilters: IIdTitle[];
    anonymityFilters: IIdTitle[];
    dynamicTimeFilters: IIdTitle[];
    panelsDynamicTimeFilters: IIdTitle[];

    activeViewTypeId: WhistleBlowPageViewTypeId;
    activeCompanyId: string;

    sortColumn: string;
    sortOrderIsAsc: boolean;
    whistleBlowSettingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showFilterDialog: boolean;
    filterDialogFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    unitNodePermissions: IUnitNodePermissions;
    // DefaultHandlers
    unitDefaultHandlersNode: IUnitDefaultHandlersNode;
    // Channel Settings
    showChannelSettingsDialog: boolean;
    // Unit Module
    unitModuleDialogNode: IUnitModuleNode;
    // Archive
    showArchiveWhistleBlowsDialog: boolean;
    // Reports
    loadingReports: boolean;
    reports: IReportItem[];
    savedReports: IReportItem[];
    reportChartItems: IChartItem[];
    activeReportId: string;
    activeSavedReportId: string;
    reportFilterReport: IReportItem;
    showReportSaveDialog: boolean;
    reportSaveDialogReport: IReportItem;
    reportSaveDialogGeneralFilter: any;
    reportSaveDialogReservedNames: string[];
    reportSaveDialogOnGetReportSaveFilters: () => ISaveReportFilters;
    // Dashboard
    showDashBoardNavPanel: boolean;
    dashBoardPanels: IPagePanel[];
    showDashBoardChartPanelDialog: boolean;
    dashBoardChartPanelDialogFilter: IWhistleBlowPageFilterState;
    dashBoardChartPanelDialogVisible: boolean;
    dashBoardChartPanelDialogPanelSize: number;
    dashBoardChartPanelDialogCharts: IIdTitle[];
    dashBoardChartPanelDialogChartId: string;
    dashBoardChartPanelId: string;
}

export class WhistleBlowPage extends React.Component<WhistleBlowPageProp, IWhistleBlowPageState> {
    _isMounted: boolean;

    getUnits = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(units);
    };
    
    getCategories = (categories: IWhistleBlowCategoryListItem[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(categories.map(i => IdTitle.createIdTitle(i.id, i.code)));
    };
    
    getHandlers = (handlers: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(handlers);
    };
    
    getStateFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(WhistleBlowStateFilter.Active.toString(10), "'" + Translations.ActivePlural + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowStateFilter.All.toString(10), "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowStateFilter.UnreadMessages.toString(10), "'" + Translations.WhistleBlowStatisticsUnreadMessages + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowState.New.toString(10), Translations.WhistleBlowStateNew));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Received.toString(10), Translations.WhistleBlowStateReceived));
        result.push(IdTitle.createIdTitle(WhistleBlowState.InProgress.toString(10), Translations.WhistleBlowStateInProgress));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Resolved.toString(10), Translations.WhistleBlowStateResolved));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Archived.toString(10), Translations.WhistleBlowStateArchived));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Archived3.toString(10), Translations.WhistleBlowStateArchived + " (" + Translations.AType.toLocaleLowerCase() + " 1)"));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Archived2.toString(10), Translations.WhistleBlowStateArchived + " (" + Translations.AType.toLocaleLowerCase() + " 2)"));
        result.push(IdTitle.createIdTitle(WhistleBlowState.Archived1.toString(10), Translations.WhistleBlowStateArchived + " (" + Translations.AType.toLocaleLowerCase() + " 3)"));
        return result;
    };
    
    getSeverityFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.Unspecified.toString(10), Translations.WhistleBlowSeverityUnspecified));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.VeryLow.toString(10), Translations.WhistleBlowSeverityVeryLow));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.Low.toString(10), Translations.WhistleBlowSeverityLow));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.Normal.toString(10), Translations.WhistleBlowSeverityNormal));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.High.toString(10), Translations.WhistleBlowSeverityHigh));
        result.push(IdTitle.createIdTitle(WhistleBlowSeverity.Critical.toString(10), Translations.WhistleBlowSeverityCritical));
        return result;
    };
    
    getResolutionFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Unspecified.toString(10), Translations.WhistleBlowResolutionUnspecified));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Resolved.toString(10), Translations.WhistleBlowResolutionResolved));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Rejected.toString(10), Translations.WhistleBlowResolutionRejected));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Canceled.toString(10), Translations.WhistleBlowResolutionCanceled));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Junk.toString(10), Translations.WhistleBlowResolutionJunk));
        result.push(IdTitle.createIdTitle(WhistleBlowResolution.Other.toString(10), Translations.WhistleBlowResolutionOther));
        return result;
    };
    
    getSourceFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Unspecified.toString(10), Translations.WhistleBlowSourceUnspecified));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.System.toString(10), Translations.WhistleBlowSourceSystem));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Phone.toString(10), Translations.WhistleBlowSourcePhone));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Email.toString(10), Translations.WhistleBlowSourceEmail));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Mail.toString(10), Translations.WhistleBlowSourceMail));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Oral.toString(10), Translations.WhistleBlowSourceOral));
        result.push(IdTitle.createIdTitle(WhistleBlowSource.Other.toString(10), Translations.WhistleBlowSourceOther));
        return result;
    };

    getAnonymityFilters = (): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        result.push(IdTitle.createIdTitle(WhistleBlowAnonymity.Anonymous.toString(10), Translations.WhistleBlowAnonymityAnonymous));
        result.push(IdTitle.createIdTitle(WhistleBlowAnonymity.NonAnonymous.toString(10), Translations.WhistleBlowAnonymityNonAnonymous));
        return result;
    };
    
    getDynamicTimeFilters = (allLabelText: string): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("0", "'" + allLabelText + "'"));
        result.push(IdTitle.createIdTitle("1", Translations.Last30Days));
        result.push(IdTitle.createIdTitle("2", Translations.Last120Days));
        result.push(IdTitle.createIdTitle("3", Translations.Last180Days));
        result.push(IdTitle.createIdTitle("4", Translations.LastYear));
        result.push(IdTitle.createIdTitle("5", Translations.Last2Years));
        result.push(IdTitle.createIdTitle("6", Translations.Last5Years));
        return result;
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowActiveReports, Translations.WhistleBlowActiveReports,
            {
                stateFilterId: WhistleBlowStateFilter.Active.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 0));
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowStateNew, Translations.WhistleBlowStateNew,
            {
                stateFilterId: WhistleBlowState.New.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 1));
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowStateReceived, Translations.WhistleBlowStateReceived,
            {
                stateFilterId: WhistleBlowState.Received.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 2));
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowStateInProgress, Translations.WhistleBlowStateInProgress,
            {
                stateFilterId: WhistleBlowState.InProgress.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 3));
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowStateResolved, Translations.WhistleBlowStateResolved,
            {
                stateFilterId: WhistleBlowState.Resolved.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 4));
        result.push(ListFilterItem.createListFilterItem(Translations.WhistleBlowStateArchived, Translations.WhistleBlowStateArchived,
            {
                stateFilterId: WhistleBlowState.Archived.toString(10),
                severityFilterId: null,
                resolutionFilterId: null,
                sourceFilterId: null,
                anonymityFilterId: null,
                categoryIds: [Base.emptyGuid],
                unitIds: [Base.emptyGuid]
            }, "state", true, 5));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getSavedFilters = (props: WhistleBlowPageProp): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        if (!props || !props.whistleBlowPage) return result;
        for (const companyFilter of props.whistleBlowPage.companyFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(companyFilter, true));
        }
        for (const userFilter of props.whistleBlowPage.userFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(userFilter, false));
        }
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: IWhistleBlowPageState): boolean => {
        return WhistleBlowFilter.filterIsSet(state.units, state.categories, state.handlers, state.stateFilters, state.severityFilters,
            state.resolutionFilters, state.sourceFilters, state.anonymityFilters, state.dynamicTimeFilters,
            state.selectedStartDate, state.selectedEndDate, state.selectedUnitIds, state.selectedCategoryIds,
            state.selectedHandlerUserCodes, state.selectedStateFilterId, state.selectedSeverityFilterId, state.selectedResolutionFilterId,
            state.selectedSourceFilterId, state.selectedAnonymityFilterId, state.selectedDynamicTimeFilterId
        );
    };

    getWhistleBlowSettingsActions = (): IPageNavMenuItem[] => {
        const props = this.props;
        const sessionState = props.appState.state;
        const result: IPageNavMenuItem[] = [];
        const canChangeProperties = sessionState?.isSuperAdmin || sessionState?.isCompanyWhistleBlowAdmin;
        if (canChangeProperties) {
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Units, title: Translations.Units });
        }
        if (props.whistleBlowPage?.canEditPermssions) {
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
        }
        if (canChangeProperties) {
            result.push({ id: WhistleBlowSettingsDialogMenuItem.General, title: Translations.BasicInformation });
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Admins, title: Translations.Admins });
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Texts, title: Translations.WhistleBlowFrontPage });
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Infos, title: Translations.WhistleBlowGuide });
        }
        if (canChangeProperties) {
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Handlers, title: Translations.DefaultHandlers });
            result.push({ id: WhistleBlowSettingsDialogMenuItem.Categories, title: Translations.WhistleBlowCategories });
        }
        return result;
    };

    getDefaultWhistleBlowPageViewTypeId = (props: WhistleBlowPageProp): WhistleBlowPageViewTypeId => {
        if (!props.match.params.page) return WhistleBlowPageViewTypeId.Dashboard;
        if (props.match.params.page.equalIgnoreCase("list")) return WhistleBlowPageViewTypeId.Records;
        if (props.match.params.page.equalIgnoreCase("reports")) return WhistleBlowPageViewTypeId.Reports;
        return WhistleBlowPageViewTypeId.Dashboard;
    };

    constructor(props: WhistleBlowPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter);
        const stateFilters = this.getStateFilters();
        const severityFilters = this.getSeverityFilters();
        const resolutionFilters = this.getResolutionFilters();
        const sourceFilters = this.getSourceFilters();
        const anonymityFilters = this.getAnonymityFilters();
        const dynamicTimeFilters = this.getDynamicTimeFilters(Translations.SpecifedTimeFrame);
        const panelsDynamicTimeFilters = this.getDynamicTimeFilters(Translations.All);
        const state: IWhistleBlowPageState = {
            ...filterProps,
            initialized: !!props.whistleBlowPage,
            activeViewTypeId: this.getDefaultWhistleBlowPageViewTypeId(props),
            activeCompanyId: sessionState.companyId,
            units: this.getUnits(props.whistleBlowPage ? props.whistleBlowPage.units : []),
            categories: this.getCategories(props.whistleBlowPage ? props.whistleBlowPage.categories : []),
            handlers: this.getHandlers(props.whistleBlowPage ? props.whistleBlowPage.handlers : []),
            stateFilters,
            severityFilters,
            resolutionFilters,
            sourceFilters,
            anonymityFilters,
            dynamicTimeFilters,
            panelsDynamicTimeFilters,
            whistleBlowSettingsActions: this.getWhistleBlowSettingsActions(),
            // Filters
            listFilterIsSet: false,
            activeFilterId: filter.id,
            activeSavedFilterId: "",
            filters,
            savedFilters: this.getSavedFilters(props),
            showFilterDialog: false,
            filterDialogFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            unitNodePermissions: null,
            // DefaultHandlers
            unitDefaultHandlersNode: null,
            // Channel Settings
            showChannelSettingsDialog: false,
            // Unit Module
            unitModuleDialogNode: null,
            // Archive
            showArchiveWhistleBlowsDialog: false,
            // Reports
            loadingReports: true,
            reports: this.getHtlmlReportItems(),
            savedReports: [],
            reportChartItems: [],
            activeReportId: "",
            activeSavedReportId: "",
            reportFilterReport: null,
            showReportSaveDialog: false,
            reportSaveDialogReport: null,
            reportSaveDialogGeneralFilter: null,
            reportSaveDialogReservedNames: [],
            reportSaveDialogOnGetReportSaveFilters: null,
            // Dashboard
            showDashBoardNavPanel: false,
            dashBoardPanels: [],
            showDashBoardChartPanelDialog: false,
            dashBoardChartPanelDialogFilter: null,
            dashBoardChartPanelDialogVisible: false,
            dashBoardChartPanelDialogPanelSize: FrontPagePanelSize.OneXOne,
            dashBoardChartPanelDialogCharts: [],
            dashBoardChartPanelDialogChartId: "",
            dashBoardChartPanelId: ""
        };
        this.state = {
            ...state,
            dashBoardPanels: this.getDashBoardPanels(state.reportChartItems),
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setWhistleBlowListDefaultFilter(null);
    }

    getDashBoardPanels = (chartItems: IChartItem[]): IPagePanel[] => {
        const props = this.props;
        const result = (props.whistleBlowPage ? props.whistleBlowPage.panels : []);
        const chartPanels = props.whistleBlowPage ? props.whistleBlowPage.chartPanels : [];
        const newChartPanels: ISavedChartPanel[] = [];
        //Set chart panel titles and add missing chart panels
        for (const chartItem of chartItems) {
            let chartPanel = chartPanels.find(i => i.reportId === chartItem.reportName);
            if (chartPanel) {
                chartPanel.reportTitle = chartItem.reportDescription;
            } else {
                chartPanel = SavedChartPanel.CreateSavedChartPanel(chartItem, result.length, ApplicationPermissionType.WhistleBlow);
            }
            newChartPanels.push(chartPanel);
        }
        return PagePanel.sortPagePanels(result.concat(newChartPanels));
    };

    getReports = async (companyId: string) => {
        const state = this.state;
        const newState = await ReportItems.getReportsState(companyId, state.activeReportId, state.activeSavedReportId, this.getHtlmlReportItems(), whistleBlowService.getWhistleBlowPageReportItems,
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: true });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: false });
            });
        if (!this._isMounted || !newState) return;
        this.setState({ ...newState, dashBoardPanels: this.getDashBoardPanels(newState.reportChartItems) });
    };

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetWhistleBlowPage();
        this.getReports(null);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: WhistleBlowPageProp, prevState: IWhistleBlowPageState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.whistleBlowPage ? prevProps.whistleBlowPage.companies.map(i => i.id) : [], props.whistleBlowPage ? props.whistleBlowPage.companies.map(i => i.id) : []);
        const prevCompanyId = prevProps.whistleBlowPage && prevProps.whistleBlowPage.companies.length > 0 ? prevProps.whistleBlowPage.companies[0].id : Base.emptyGuid;
        const companyId = props.whistleBlowPage && props.whistleBlowPage.companies.length > 0 ? props.whistleBlowPage.companies[0].id : Base.emptyGuid;
        const prevCanEditPermssions = prevProps.whistleBlowPage?.canEditPermssions ?? false;
        const canEditPermssions = props.whistleBlowPage?.canEditPermssions ?? false;
        const unitsData = props.whistleBlowPage ? props.whistleBlowPage.units : [];
        const equalUnits = Base.equalStrArrays(prevProps.whistleBlowPage ? prevProps.whistleBlowPage.units.map(i => i.id) : [], unitsData.map(i => i.id));
        const units = this.getUnits(unitsData);
        const prevCategoriesHash = prevProps.whistleBlowPage ? IdTitle.getHash(prevProps.whistleBlowPage.categories.map(i => IdTitle.createIdTitle(i.id, i.code))) : "";
        const categoriesData = props.whistleBlowPage ? props.whistleBlowPage.categories : [];
        const categoriesHash = IdTitle.getHash(categoriesData.map(i => IdTitle.createIdTitle(i.id, i.code)));
        const categories = this.getCategories(categoriesData);
        const prevHandlersHash = prevProps.whistleBlowPage ? IdTitle.getHash(prevProps.whistleBlowPage.handlers) : "";
        const handlersData = props.whistleBlowPage ? props.whistleBlowPage.handlers : [];
        const handlersHash = IdTitle.getHash(handlersData);
        const handlers = this.getHandlers(handlersData);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditPermssions === canEditPermssions &&
            equalCompanyIds && equalUnits && prevCategoriesHash === categoriesHash && prevHandlersHash === handlersHash) return;
        const savedFilters = this.getSavedFilters(props);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const selectedCategoryIds = prevCategoriesHash === categoriesHash ? state.selectedCategoryIds : [Base.emptyGuid];
        const selectedHandlerUserCodes = prevHandlersHash === handlersHash ? state.selectedHandlerUserCodes : [""];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            initialized: !!props.whistleBlowPage,
            dashBoardPanels: this.getDashBoardPanels(state.reportChartItems),
            activeViewTypeId: companyId !== sessionState.companyId
                ? WhistleBlowPageViewTypeId.Records
                : state.activeViewTypeId,
            activeCompanyId: companyId,
            units,
            categories,
            handlers,
            selectedUnitIds,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            savedFilters,
            activeSavedFilterId,
            whistleBlowSettingsActions: this.getWhistleBlowSettingsActions()
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null) => {
        const state = this.state;
        let result = {
            selectedStartDate: state.selectedStartDate,
            selectedEndDate: state.selectedEndDate,
            selectedUnitIds: state.selectedUnitIds,
            selectedCategoryIds: state.selectedCategoryIds,
            selectedHandlerUserCodes: state.selectedHandlerUserCodes,
            selectedStateFilterId: state.selectedStateFilterId,
            selectedSeverityFilterId: state.selectedSeverityFilterId,
            selectedResolutionFilterId: state.selectedResolutionFilterId,
            selectedSourceFilterId: state.selectedSourceFilterId,
            selectedAnonymityFilterId: state.selectedAnonymityFilterId,
            selectedDynamicTimeFilterId: state.selectedDynamicTimeFilterId,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshUnitsAndCategories(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return;
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return;
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.WhistleBlow);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showFilterDialog: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            filterDialogFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, WhistleBlowPageDashboardChart.getGeneralFilterFromState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.WhistleBlow);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: WhistleBlowPageDashboardChart.getGeneralFilterFromState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleOpenWhistleBlowFilterDialog = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showFilterDialog: this.state.activeViewTypeId !== WhistleBlowPageViewTypeId.Reports,
            filterDialogFilter: filter
        });
    };

    handleWhistleBlowFilterDialogOk = (closeDialog: boolean, selectedStartDate: number, selectedEndDate: number, selectedStateFilterId: string, selectedSeverityFilterId: string, selectedResolutionFilterId: string,
        selectedSourceFilterId: string, selectedAnonymityFilterId: string, selectedDynamicTimeFilterId: string, selectedCategoryIds: string[], selectedHandlerUserCodes: string[], selectedUnitIds: string[]): any => {
        const newState = {
            ...this.state,
            selectedStartDate,
            selectedEndDate,
            selectedStateFilterId,
            selectedSeverityFilterId,
            selectedResolutionFilterId,
            selectedSourceFilterId,
            selectedAnonymityFilterId,
            selectedDynamicTimeFilterId,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            selectedUnitIds
        };
        this.setState({
            showFilterDialog: !closeDialog,
            selectedStartDate,
            selectedEndDate,
            selectedStateFilterId,
            selectedSeverityFilterId,
            selectedResolutionFilterId,
            selectedSourceFilterId,
            selectedAnonymityFilterId,
            selectedDynamicTimeFilterId,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            selectedUnitIds,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return WhistleBlowPageDashboardChart.getGeneralFilterFromState(newState);
    };
    
    handleWhistleBlowFilterDialogCancel = () => {
        this.setState({ showFilterDialog: false });
    };
    // #endregion Record Filter

    // #region Report Filter
    getStateChangeAfterChangeActiveReport = (activeReportId: string) => {
        return getStateChangeAfterChangeActiveReport(
            this.state,
            (generalFilter) => WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter(generalFilter, WhistleBlowStateFilter.All.toString(10)),
            this.getListFilterIsSet,
            activeReportId
        );
    };

    handleChangeActiveReport = (activeReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveReport(activeReportId));
    };

    getStateChangeAfterChangeActiveSavedReport = (activeSavedReportId: string): any => {
        return getStateChangeAfterChangeActiveSavedReport(
            this.state,
            (generalFilter) => WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter(generalFilter, WhistleBlowStateFilter.All.toString(10)),
            this.getListFilterIsSet,
            activeSavedReportId);
    };

    handleChangeActiveSavedReport = (activeSavedReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedReport(activeSavedReportId));
    };

    handleRemoveSavedReport = async (reportId: string) => {
        this.setState(await handleRemoveSavedReport(
            this.state,
            (generalFilter) => WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter(generalFilter, WhistleBlowStateFilter.All.toString(10)),
            this.getListFilterIsSet,
            ApplicationPermissionType.WhistleBlow,
            SaveReportDialog.removeReportFromDb,
            reportId
        ));
    };
    // #endregion Report

    handleSetActiveViewType = (itemId: WhistleBlowPageViewTypeId, activeFilterId: string = null, additionalGeneralFilter: any = null) => {
        const state = this.state;
        //To reset filter when filter/report is activated
        let newState = {};
        if (itemId === WhistleBlowPageViewTypeId.Reports) {
            if (state.activeReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(state.activeReportId);
            } else if (state.activeSavedReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(state.activeSavedReportId);
            }
            const report = this.getActiveReport();
            if (!report) return;
            newState = { reportFilterReport: report };
        } else if (itemId === WhistleBlowPageViewTypeId.Records) {
            if (activeFilterId ?? state.activeFilterId) {
                newState = this.getStateChangeAfterChangeActiveFilter(activeFilterId ?? state.activeFilterId, additionalGeneralFilter);
            } else if (state.activeSavedFilterId) {
                newState = this.getStateChangeAfterChangeActiveSavedFilter(state.activeSavedFilterId);
            }
        }
        this.setState({
            ...newState,
            activeViewTypeId: itemId,
        });
    };

    // #region Permissions
    handleOpenPermissions = async () => {
        const result = await AppUtils.callService(() => whistleBlowService.getUnitNodePermissions(this.state.activeCompanyId), false);
        if (!result) return;
        this.setState({
            unitNodePermissions: result
        });
    };

    handlePermissionsDialogSave = async (obj: any) => {
        const result = await whistleBlowService.saveUnitNodePermissions(obj);
        this.handleOpenPermissions();

        return result;
    };

    handlePermissionsDialogOk = () => {
        this.setState({
            dataId: Base.getRandomIntInteger(1000000),
        });
    };

    handlePermissionsDialogCancel = (closeDialog: boolean) => {
        if (closeDialog) {
            this.setState({
                showChannelSettingsDialog: false
            });
        }
    };
    // #endregion Permissions

    // #region Units
    handleOpenUnits = async () => {
        const result = await AppUtils.callService(() => whistleBlowService.getUnits(this.state.activeCompanyId), false);
        if (!result) return;
        this.setState({
            unitModuleDialogNode: result.unitModuleNode
        });
    };

    handleRefreshUnitsAndCategories = async (companyId: string) => {
        const state = this.state;
        const whistleBlowPageData = await whistleBlowService.getWhistleBlowPageData(companyId);
        //Units and unit filter ids
        const units = this.getUnits(whistleBlowPageData.units);
        let selectedUnitIds = state.selectedUnitIds.slice(0);
        if (selectedUnitIds.length > 0 && selectedUnitIds[0] !== Base.emptyGuid) {
            const unitIds = units.map(i => i.id);
            selectedUnitIds = selectedUnitIds.filter(i => unitIds.indexOf(i) > -1);
        }
        //Categories and Category filter ids
        const categories = this.getCategories(whistleBlowPageData.categories);
        let selectedCategoryIds = state.selectedCategoryIds.slice(0);
        if (selectedCategoryIds.length > 0 && selectedCategoryIds[0] !== Base.emptyGuid) {
            const categoryIds = categories.map(i => i.id);
            selectedCategoryIds = selectedCategoryIds.filter(i => categoryIds.indexOf(i) > -1);
        }
        //Handlers and Handler filter user codes
        const handlers = this.getHandlers(whistleBlowPageData.handlers);
        let selectedHandlerUserCodes = state.selectedHandlerUserCodes.slice(0);
        if (selectedHandlerUserCodes.length > 0 && selectedHandlerUserCodes[0] !== "") {
            const handlerUserCodes = handlers.map(i => i.id);
            selectedHandlerUserCodes = selectedHandlerUserCodes.filter(i => handlerUserCodes.indexOf(i) > -1);
        }
        const stateChange = {
            activeCompanyId: companyId,
            units,
            selectedUnitIds,
            categories: this.getCategories(whistleBlowPageData.categories),
            selectedCategoryIds,
            handlers,
            selectedHandlerUserCodes
        };
        //const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            //listFilterIsSet: this.getListFilterIsSet(newState),
        });
        //DO NOT REFRESH FILTER OR REPORTS BECAUSE THEY ARE NOT VISIBLE TO OTHER COMPANIES
    };

    handleUnitModuleDialogSave = async (obj: any) => {
        const result = await whistleBlowService.saveUnits(obj);
        return result;
    };

    handleUnitModuleDialogOk = async () => {
        await this.handleRefreshUnitsAndCategories(this.state.activeCompanyId);
        // this.setState({
        //     showUnitModuleDialog: false
        // });
    };

    handleUnitModuleDialogCancel = (closeDialog: boolean) => {
        if (closeDialog) {
            this.setState({
                showChannelSettingsDialog: false
            });
        }
    };
    // #endregion Units

    // #region ChannelSettings
    handleOpenWhistleBlowChannelSettings = () => {
        this.handleOpenPermissions();
        this.handleOpenUnits();
        this.handleOpenWhistleDefaultHandlersDialog();
        this.setState({
            showChannelSettingsDialog: true
        });
    };
    
    handleWhistleBlowChannelEditDialogOk = () => {
        // this.setState({
        //     showChannelSettingsDialog: false
        // });
    };

    handleWhistleBlowChannelEditDialogCancel = (_whistleBlowChannelDataWasModified: boolean, closeDialog: boolean) => {
        if (closeDialog) {
            this.setState({
                showChannelSettingsDialog: false
            });
        }
    };
    // #endregion ChannelSettings

    // #region DefaultHandlers
    handleOpenWhistleDefaultHandlersDialog = async () => {
        const result = await AppUtils.callService(() => whistleBlowService.getUnitNodeDefaultHandlers(this.state.activeCompanyId), false);
        if (!result) return;
        this.setState({
            unitDefaultHandlersNode: result.unitNode

        });
    };

    handleWhistleDefaultHandlersDialogSave = async (obj: any) => {
        const result = await whistleBlowService.saveUnitNodeDefaultHandlers(obj);
        this.handleOpenWhistleDefaultHandlersDialog();

        return result;
    };

    handleWhistleDefaultHandlersDialogOk = () => {
        this.setState({
            dataId: Base.getRandomIntInteger(1000000),
        });
    };

    handleWhistleDefaultHandlersDialogCancel = (closeDialog: boolean) => {
        if (closeDialog) {
            this.setState({
                showChannelSettingsDialog: false
            });
        }
    };

    handleWhistleDefaultHandlersSelectListItems = (companyId: string, unitId: string, _handlerType: DefaultHandlerType, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
        return whistleBlowService.defaultHandlersGetSelectUserListItems(companyId, unitId, pageSize, page, filter,
            ignoreUserIds, ignoreUserCodes, activityState, ignoreRecordUserConnected, doNotIgnoreRecordUserConnectedUserCode,
            sortColumn, sortOrderIsAsc);
    };
    // #endregion DefaultHandlers

    // #region ArchiveWhistleBlows
    handleArchiveWhistleBlows = () => {
        this.setState({
            showArchiveWhistleBlowsDialog: true
        });
    };

    handleArchiveWhistleBlowsDialogOk = () => {
        this.setState({
            dataId: Base.getRandomIntInteger(1000000),
            showArchiveWhistleBlowsDialog: false
        });
    };

    handleArchiveWhistleBlowsDialogCancel = () => {
        this.setState({
            showArchiveWhistleBlowsDialog: false
        });
    };
    // #endregion ArchiveWhistleBlows

    // #region Report Filter
    getActiveReport = (): IReportItem => {
        const state = this.state;
        return state.activeReportId
            ? state.reports.find(i => i.id === state.activeReportId)
            : state.savedReports.find(i => i.id === state.activeSavedReportId);
    };

    onRecordReportFilterDialogOk = (closeDialog: boolean, selectedStartDate: number, selectedEndDate: number, _: string, selectedStateFilterId: string, selectedSeverityFilterId: string, selectedResolutionFilterId: string,
        selectedSourceFilterId: string, selectedAnonymityFilterId: string, selectedDynamicTimeFilterId, selectedCategoryIds: string[], selectedHandlerUserCodes: string[], selectedUnitIds: string[], parameters: ITaskDataRow): ISaveReportFilters => {
        const state = this.state;
        const reports = state.reports.slice(0);
        const savedReports = state.savedReports.slice(0);
        const index = state.activeReportId
            ? reports.findIndex(i => i.id === state.activeReportId)
            : savedReports.findIndex(i => i.id === state.activeSavedReportId);
        if (index < 0) return;
        let reportFilter = null;
        if (state.activeReportId) {
            const report = new ReportItem(reports[index]);
            report.taskDataRow = parameters;
            reportFilter = SaveReportDialog.getReportFilter(report);
            reports[index] = report;
        } else {
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.taskDataRow = parameters;
            savedReport.reportFilter = SaveReportDialog.getReportFilter(savedReport);
            reportFilter = savedReport.reportFilter;
            savedReports[index] = savedReport;
        }
        const newState = {
            ...this.state,
            selectedStartDate,
            selectedEndDate,
            selectedStateFilterId,
            selectedSeverityFilterId,
            selectedResolutionFilterId,
            selectedSourceFilterId,
            selectedAnonymityFilterId,
            selectedDynamicTimeFilterId,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            selectedUnitIds,
            reports,
            savedReports
        };
        this.setState({
            selectedStartDate,
            selectedEndDate,
            selectedStateFilterId,
            selectedSeverityFilterId,
            selectedResolutionFilterId,
            selectedSourceFilterId,
            selectedAnonymityFilterId,
            selectedDynamicTimeFilterId,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            selectedUnitIds,
            reports,
            savedReports,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return {
            generalFilter: WhistleBlowPageDashboardChart.getGeneralFilterFromState(newState),
            reportFilter,
            showInFrontPage: false
        };
    };
    // #endregion Report Filter

    // #region Report Save
    handleSetSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        const state = this.state;
        if (state.activeReportId) {
            const reports = state.reports.slice(0);
            const index = reports.findIndex(i => i.id === state.activeReportId);
            if (index < 0) return;
            const report = new ReportItem(reports[index]);
            report.sortColumn = sortColumn;
            report.sortOrderIsAsc = sortOrderIsAsc;
            reports[index] = report;
            const newState = { ...this.state, reports };
            this.setState({
                reports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        } else if (state.activeSavedReportId) {
            const savedReports = state.savedReports.slice(0);
            const index = savedReports.findIndex(i => i.id === state.activeSavedReportId);
            if (index < 0) return;
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.sortColumn = sortColumn;
            savedReport.sortOrderIsAsc = sortOrderIsAsc;
            savedReports[index] = savedReport;
            const newState = { ...this.state, savedReports };
            this.setState({
                savedReports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        }
    };

    handleSaveAsReportsModifiedReport = async (saveAs: boolean, onGetReportSaveFilters: () => ISaveReportFilters) => {
        const state = this.state;
        const report = this.getActiveReport();
        if (!report) return;
        if (!saveAs) {
            const savedReport = await SaveReportDialog.saveReportToDb(report, WhistleBlowPageDashboardChart.getGeneralFilterFromState(state), state.activeCompanyId, ApplicationPermissionType.WhistleBlow);
            this.setState(SaveReportDialog.getReportStateChangeAfterReportSave(this.state, report.id, savedReport, report.reportSharingType));
        } else {
            this.setState({
                showReportSaveDialog: true,
                reportSaveDialogReport: report,
                reportSaveDialogReservedNames: state.savedReports.map(i => i.id).concat(state.reports.map(i => i.title)),
                reportSaveDialogGeneralFilter: WhistleBlowPageDashboardChart.getGeneralFilterFromState(state),
                reportSaveDialogOnGetReportSaveFilters: onGetReportSaveFilters
            });
        }
    };

    handleReportSaveDialogOk = (savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        this.setState(SaveReportDialog.getReportStateChangeAfterReportSave(this.state, "", savedReport, reportSharingType));
    };

    handleReportSaveDialogCancel = () => {
        this.setState({
            showReportSaveDialog: false
        });
    };
    // #endregion Report Save

    // #region Dashboard
    handleToggleShowDashboardNavPanel = () => {
        this.setState({ showDashBoardNavPanel: !this.state.showDashBoardNavPanel });
    };

    handleUpdateDashBoardPanels = async (panels: IPagePanel[]) => {
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleSaveDashBoardPanels = async (panels: IPagePanel[]) => {
        const pagePanels = panels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        await whistleBlowService.saveWhistleBlowPanels(pagePanels);
        const chartPanels = panels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
        await whistleBlowService.saveWhistleBlowChartPanels(chartPanels);
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleDashboardSavedFilterClick = (filterId: string) => {
        this.handleChangeActiveSavedFilter(filterId);
        this.setState({
            activeViewTypeId: WhistleBlowPageViewTypeId.Records,
        });
    };

    handleDashboardFilterClick = (filterId: string) => {
        this.handleChangeActiveFilter(filterId);
        this.setState({
            activeViewTypeId: WhistleBlowPageViewTypeId.Records,
        });
    };

    handleDashboardSavedReportClick = (reportId: string) => {
        this.handleChangeActiveSavedReport(reportId);
        this.setState({
            activeViewTypeId: WhistleBlowPageViewTypeId.Reports,
        });
    };

    handleDashboardReportClick = (reportId: string) => {
        this.handleChangeActiveReport(reportId);
        this.setState({
            activeViewTypeId: WhistleBlowPageViewTypeId.Reports,
        });
    };

    handleShowChartPanelPropertiesDialog = (panelId: string) => {
        if (!panelId) return;
        const state = this.state;
        const chartPanels = state.dashBoardPanels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
        const chartPanel = chartPanels.find(i => i.id === panelId);
        if (!chartPanel) return;
        const chartItem = state.reportChartItems.find(i => i.reportName === chartPanel.reportId);
        if (!chartItem) return;
        const reportItem = ReportItem.createReportItem(chartItem.id, chartPanel.getTitle(), ReportType.Pdf, chartItem.taskType);
        reportItem.taskDataRow = chartItem.taskDataRow;
        reportItem.generalFilter = chartPanel.generalFilter;
        reportItem.reportFilter = chartPanel.reportFilter;
        reportItem.copyReportParameterValuesFromSavedValues();
        this.setState({
            showDashBoardChartPanelDialog: true,
            dashBoardChartPanelId: panelId,
            reportFilterReport: reportItem,
            dashBoardChartPanelDialogFilter: WhistleBlowPageDashboardChart.getStateFilterPropsFromGeneralFilter(chartPanel.generalFilter, WhistleBlowStateFilter.All.toString(10)),
            dashBoardChartPanelDialogVisible: chartPanel.visible,
            dashBoardChartPanelDialogPanelSize: chartPanel.size,
            dashBoardChartPanelDialogCharts: chartItem.chartNames.map(i => IdTitle.createIdTitle(i, i)),
            dashBoardChartPanelDialogChartId: chartPanel.chartId,
        });
    };
    
    handleChartPanelReportFilterDialogOk = async (selectedStartDate: number, selectedEndDate: number, selectedChartId: string, selectedStateFilterId: string, selectedSeverityFilterId: string, selectedResolutionFilterId: string,
        selectedSourceFilterId: string, selectedAnonymityFilterId: string, selectedDynamicTimeFilterId: string, selectedCategoryIds: string[], selectedHandlerUserCodes: string[], selectedUnitIds: string[], parameters: ITaskDataRow,
        panelSize: number, panelVisible: boolean) => {
        const state = this.state;
        const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        const chartPanels = state.dashBoardPanels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
        const chartPanel = chartPanels.find(i => i.id === state.dashBoardChartPanelId);
        if (!chartPanel) return;
        const chartItem = state.reportChartItems.find(i => i.reportName === chartPanel.reportId);
        if (!chartItem) return;
        const newState = {
            ...this.state,
            selectedStartDate,
            selectedEndDate,
            selectedStateFilterId,
            selectedSeverityFilterId,
            selectedResolutionFilterId,
            selectedSourceFilterId,
            selectedAnonymityFilterId,
            selectedDynamicTimeFilterId,
            selectedCategoryIds,
            selectedHandlerUserCodes,
            selectedUnitIds
        };
        chartPanel.size = panelSize;
        chartPanel.visible = panelVisible;
        chartPanel.chartId = selectedChartId;
        chartPanel.generalFilter = WhistleBlowPageDashboardChart.getGeneralFilterFromState(newState);
        chartPanel.reportFilter = SaveReportDialog.getReportFilterFromTaskType(chartItem.taskType, parameters);
        this.setState({
            showDashBoardChartPanelDialog: false,
            dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
        });
        await whistleBlowService.saveWhistleBlowChartPanels([chartPanel]);
    };
    
    handleChartPanelReportFilterDialogCancel = () => {
        this.setState({
            showDashBoardChartPanelDialog: false
        });
    };

    static getDefaultListFilter = (toDoItem: IFrontToDoItem): TDefaultListFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id === "WhistleBlowUnreadMessageCount") {
            return {
                filterId: Translations.WhistleBlowActiveReports,
                generalFilter: {
                    stateFilterId: WhistleBlowStateFilter.UnreadMessages.toString(10)
                }
            };
        }
        return {
            filterId: toDoItem.id === "WhistleBlowNewRecordCount"
                ? Translations.WhistleBlowStateNew
                : (toDoItem.id === "WhistleBlowReceivedRecordCount"
                    ? Translations.WhistleBlowStateReceived
                    : (toDoItem.id === "WhistleBlowInProgressRecordCount"
                        ? Translations.WhistleBlowStateInProgress
                        : (toDoItem.id === "WhistleBlowResolvedRecordCount"
                            ? Translations.WhistleBlowStateResolved
                            : Translations.WhistleBlowActiveReports
                        )
                    )
                )
        };
    };
    
    handleToItemClick = (toDoItem: IFrontToDoItem) => {
        const defaultListFilter = WhistleBlowPage.getDefaultListFilter(toDoItem);
        this.handleSetActiveViewType(WhistleBlowPageViewTypeId.Records, defaultListFilter?.filterId, defaultListFilter?.generalFilter);
    };
    // #endregion Dashboard

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.whistleBlowPage ? props.whistleBlowPage.companies : [];
        const userCompanyIsActiveCompany = state.activeCompanyId === sessionState.companyId;
        const dashboardViewIsActive = state.activeViewTypeId === WhistleBlowPageViewTypeId.Dashboard;
        const recordsViewIsActive = state.activeViewTypeId === WhistleBlowPageViewTypeId.Records;
        const reportsViewIsActive = state.activeViewTypeId === WhistleBlowPageViewTypeId.Reports;
        const settingsVisible = state.whistleBlowSettingsActions?.length > 0;
        return (
            // TODO: Remove margin
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.WhistleBlow}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar justifyContent="space-between">
                        <PageTabs
                            activeTabId={state.activeViewTypeId}
                            tabs={[
                                { id: WhistleBlowPageViewTypeId.Dashboard, title: Translations.FrontPage },
                                { id: WhistleBlowPageViewTypeId.Records, title: Translations.WhistleBlowRecords },
                                { id: WhistleBlowPageViewTypeId.Reports, title: Translations.Reports }
                            ]}
                            changeTab={this.handleSetActiveViewType}
                        />
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    {!userCompanyIsActiveCompany &&
                        <Box display="flex" flexDirection="column" sx={{ margin: "0 1rem" }}>
                            <PageTitle title={Translations.WhistleBlowDashboard}>
                                {settingsVisible
                                    ? (
                                        <SettingsButton onClick={this.handleOpenWhistleBlowChannelSettings}>
                                            {Translations.Settings}
                                        </SettingsButton>
                                    )
                                    : null}
                            </PageTitle>
                        </Box>
                    }
                    {!dashboardViewIsActive &&
                    <PageListAndReportsContainer>
                        {userCompanyIsActiveCompany && recordsViewIsActive &&
                            <WhistleBlowList
                                filterName={state.activeSavedFilterId
                                    ? state.savedFilters.find(i => i.id === state.activeSavedFilterId)?.title
                                    : state.activeFilterId && state.activeFilterId !== Translations.WhistleBlowActiveReports
                                        ? state.filters.find(i => i.id === state.activeFilterId)?.title
                                        : null}
                                sessionState={sessionState}
                                dataId={state.dataId.toString(10)}
                                maxAttachmentsTotalSize={props.whistleBlowPage?.maxAttachmentsTotalSize}
                                listFilterIsSet={state.listFilterIsSet}
                                units={state.units}
                                selectedStartDate={state.selectedStartDate}
                                selectedEndDate={state.selectedEndDate}
                                selectedUnitIds={state.selectedUnitIds}
                                selectedCategoryIds={state.selectedCategoryIds}
                                selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                selectedStateFilterId={state.selectedStateFilterId}
                                selectedSeverityFilterId={state.selectedSeverityFilterId}
                                selectedResolutionFilterId={state.selectedResolutionFilterId}
                                selectedSourceFilterId={state.selectedSourceFilterId}
                                selectedAnonymityFilterId={state.selectedAnonymityFilterId}
                                selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                companyId={state.activeCompanyId}
                                sortColumn={state.sortColumn}
                                sortOrderIsAsc={state.sortOrderIsAsc}
                                onOpenFiltersDialog={this.handleOpenWhistleBlowFilterDialog}
                                onSetSortData={this.handleFilterSortData}
                                onLoadPageData={() => this.handleRefreshUnitsAndCategories(state.activeCompanyId)}
                                onArchive={this.handleArchiveWhistleBlows}
                                reportTabs={(
                                    <FilterTabs
                                        items={state.savedFilters}
                                        standardFilters={state.filters}
                                        selectedId={this.state.activeFilterId}
                                        selectedSavedId={this.state.activeSavedFilterId}
                                        onSetActiveItem={this.handleChangeActiveSavedFilter}
                                        onSetActiveStandardItem={this.handleChangeActiveFilter}
                                    />
                                )}
                            />
                        }
                        {userCompanyIsActiveCompany && reportsViewIsActive &&
                            <PageReportsContainer>
                                <WhistleBlowReportList
                                    companyId={state.activeCompanyId}
                                    reports={state.activeReportId ? state.reports : state.savedReports}
                                    reportId={state.activeReportId ? state.activeReportId : state.activeSavedReportId}
                                    selectedStartDate={state.selectedStartDate}
                                    selectedEndDate={state.selectedEndDate}
                                    selectedUnitIds={state.selectedUnitIds}
                                    selectedCategoryIds={state.selectedCategoryIds}
                                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                    selectedStateFilterId={state.selectedStateFilterId}
                                    selectedSeverityFilterId={state.selectedSeverityFilterId}
                                    selectedResolutionFilterId={state.selectedResolutionFilterId}
                                    selectedSourceFilterId={state.selectedSourceFilterId}
                                    selectedAnonymityFilterId={state.selectedAnonymityFilterId}
                                    selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                    onSetSortData={this.handleSetSortData}
                                />
                                <ReportSettings
                                    filters={
                                        <WhistleBlowReportFilterPanel
                                            report={state.reportFilterReport}
                                            units={state.units}
                                            categories={state.categories}
                                            handlers={state.handlers}
                                            stateFilters={state.stateFilters}
                                            severityFilters={state.severityFilters}
                                            resolutionFilters={state.resolutionFilters}
                                            sourceFilters={state.sourceFilters}
                                            anonymityFilters={state.anonymityFilters}
                                            dynamicTimeFilters={state.dynamicTimeFilters}
                                            panelsDynamicTimeFilters={state.panelsDynamicTimeFilters}
                                            selectedStartDate={state.selectedStartDate}
                                            selectedEndDate={state.selectedEndDate}
                                            selectedUnitIds={state.selectedUnitIds}
                                            selectedCategoryIds={state.selectedCategoryIds}
                                            selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                            selectedStateFilterId={state.selectedStateFilterId}
                                            selectedSeverityFilterId={state.selectedSeverityFilterId}
                                            selectedResolutionFilterId={state.selectedResolutionFilterId}
                                            selectedSourceFilterId={state.selectedSourceFilterId}
                                            selectedAnonymityFilterId={state.selectedAnonymityFilterId}
                                            selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                            canRemoveSharedReports={sessionState.isSuperAdmin}
                                            onSaveReport={this.handleSaveAsReportsModifiedReport}
                                            onRemoveReport={this.handleRemoveSavedReport}
                                            onOk={this.onRecordReportFilterDialogOk}
                                            onCancel={null}
                                        />
                                    }
                                    reports={
                                        <PageNavMenuReportList
                                            canRemoveSharedReports={sessionState.isSuperAdmin}
                                            items={state.savedReports}
                                            standardReports={state.reports}
                                            activeItemId={state.activeSavedReportId}
                                            activeStandardItemId={state.activeReportId}
                                            showingSavedReports={true}
                                            title={Translations.Report}
                                            onSetActiveItem={this.handleChangeActiveSavedReport}
                                            onSetActiveStandardItem={this.handleChangeActiveReport}
                                        />
                                    } />
                            </PageReportsContainer>
                        }
                    </PageListAndReportsContainer>
                    }
                    {userCompanyIsActiveCompany && dashboardViewIsActive &&
                        <DashboardPanelList
                            companyId={state.activeCompanyId}
                            applicationPermissionType={ApplicationPermissionType.WhistleBlow}
                            canSharePanels={false}
                            hidden={!state.showDashBoardNavPanel}
                            panels={state.dashBoardPanels}
                            onUpdatePanels={this.handleUpdateDashBoardPanels}
                            onSavePanels={this.handleSaveDashBoardPanels}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onShowChartPanelProperties={this.handleShowChartPanelPropertiesDialog}
                        />
                    }
                    {userCompanyIsActiveCompany && dashboardViewIsActive &&
                        <PageDashboard
                            title={Translations.WhistleBlowDashboard}
                            settingsVisible={settingsVisible}
                            panels={state.dashBoardPanels}
                            companyId={state.activeCompanyId}
                            filters={state.filters}
                            savedFilters={state.savedFilters}
                            loadingReports={state.loadingReports}
                            reports={state.reports}
                            savedReports={state.savedReports}
                            chartItems={state.reportChartItems}
                            dashboardChart={WhistleBlowPageDashboardChart}
                            onSavedFilterClick={this.handleDashboardSavedFilterClick}
                            onFilterClick={this.handleDashboardFilterClick}
                            onSavedReportClick={this.handleDashboardSavedReportClick}
                            onReportClick={this.handleDashboardReportClick}
                            onShowChartPanelPropertiesDialog={this.handleShowChartPanelPropertiesDialog}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onToggleSettingsDialog={this.handleOpenWhistleBlowChannelSettings}
                            onGetToDoItems={whistleBlowService.getWhistleBlowToDoItems}
                            onStatisticsClick={this.handleToItemClick}
                        />
                    }
                </PageContent>
                <PageFilterConditionDrawer
                    open={state.showFilterDialog}
                    onClose={this.handleWhistleBlowFilterDialogCancel}
                >
                    <Box display="flex" flexDirection="column" flexGrow={2} margin="24px">
                        <WhistleBlowFilter
                            filter={state.filterDialogFilter}
                            units={state.units}
                            categories={state.categories}
                            handlers={state.handlers}
                            stateFilters={state.stateFilters}
                            severityFilters={state.severityFilters}
                            resolutionFilters={state.resolutionFilters}
                            sourceFilters={state.sourceFilters}
                            anonymityFilters={state.anonymityFilters}
                            dynamicTimeFilters={state.dynamicTimeFilters}
                            selectedStartDate={state.selectedStartDate}
                            selectedEndDate={state.selectedEndDate}
                            selectedUnitIds={state.selectedUnitIds}
                            selectedCategoryIds={state.selectedCategoryIds}
                            selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                            selectedStateFilterId={state.selectedStateFilterId}
                            selectedSeverityFilterId={state.selectedSeverityFilterId}
                            selectedResolutionFilterId={state.selectedResolutionFilterId}
                            selectedSourceFilterId={state.selectedSourceFilterId}
                            selectedAnonymityFilterId={state.selectedAnonymityFilterId}
                            selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                            canRemoveSharedFilters={sessionState.isCompanyAdmin}
                            size="sm"
                            onSaveFilter={this.handleSaveListFilter}
                            onRemoveFilter={this.handleRemoveSavedFilter}
                            onOk={this.handleWhistleBlowFilterDialogOk}
                            onCancel={this.handleWhistleBlowFilterDialogCancel}
                        />
                    </Box>
                </PageFilterConditionDrawer>
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.WhistleBlow}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showDashBoardChartPanelDialog &&
                    <WhistleBlowReportFilterPanel
                        chartPanelDrawerMode={true}
                        report={state.reportFilterReport}
                        units={state.units}
                        charts={state.dashBoardChartPanelDialogCharts}
                        categories={state.categories}
                        handlers={state.handlers}
                        stateFilters={state.stateFilters}
                        severityFilters={state.severityFilters}
                        resolutionFilters={state.resolutionFilters}
                        sourceFilters={state.sourceFilters}
                        anonymityFilters={state.anonymityFilters}
                        dynamicTimeFilters={state.dynamicTimeFilters}
                        panelsDynamicTimeFilters={state.panelsDynamicTimeFilters}
                        selectedChartId={state.dashBoardChartPanelDialogChartId}
                        selectedStartDate={state.dashBoardChartPanelDialogFilter.selectedStartDate}
                        selectedEndDate={state.dashBoardChartPanelDialogFilter.selectedEndDate}
                        selectedUnitIds={state.dashBoardChartPanelDialogFilter.selectedUnitIds}
                        selectedCategoryIds={state.dashBoardChartPanelDialogFilter.selectedCategoryIds}
                        selectedHandlerUserCodes={state.dashBoardChartPanelDialogFilter.selectedHandlerUserCodes}
                        selectedStateFilterId={state.dashBoardChartPanelDialogFilter.selectedStateFilterId}
                        selectedSeverityFilterId={state.dashBoardChartPanelDialogFilter.selectedSeverityFilterId}
                        selectedResolutionFilterId={state.dashBoardChartPanelDialogFilter.selectedResolutionFilterId}
                        selectedSourceFilterId={state.dashBoardChartPanelDialogFilter.selectedSourceFilterId}
                        selectedAnonymityFilterId={state.dashBoardChartPanelDialogFilter.selectedAnonymityFilterId}
                        selectedDynamicTimeFilterId={state.dashBoardChartPanelDialogFilter.selectedDynamicTimeFilterId}
                        panelSize={state.dashBoardChartPanelDialogPanelSize}
                        panelVisible={state.dashBoardChartPanelDialogVisible}
                        canRemoveSharedReports={false}
                        onSaveReport={null}
                        onRemoveReport={null}
                        onOk={null}
                        onOkChart={this.handleChartPanelReportFilterDialogOk}
                        onCancel={this.handleChartPanelReportFilterDialogCancel}
                    />
                }
                {state.showReportSaveDialog &&
                    <SaveReportDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.WhistleBlow}
                        report={state.reportSaveDialogReport}
                        generalFilter={state.reportSaveDialogGeneralFilter}
                        reservedNames={state.reportSaveDialogReservedNames}
                        onGetReportSaveFilters={state.reportSaveDialogOnGetReportSaveFilters}
                        onOk={this.handleReportSaveDialogOk}
                        onCancel={this.handleReportSaveDialogCancel}
                    />
                }
                {state.showChannelSettingsDialog &&
                    <WhistleBlowSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        whistleBlowSettingsActions={state.whistleBlowSettingsActions}
                        unitModuleNode={state.unitModuleDialogNode}
                        unitDefaultHandlersNode={state.unitDefaultHandlersNode}
                        unitNodePermissions={state.unitNodePermissions}
                        validAdditionalPermissions={props.whistleBlowPage?.validAdditionalPermissions}
                        onRefreshSessionState={props.onRefreshSessionState}
                        onOk={this.handleWhistleBlowChannelEditDialogOk}
                        onCancel={this.handleWhistleBlowChannelEditDialogCancel}
                        onUnitModuleDialogSave={this.handleUnitModuleDialogSave}
                        onUnitModuleDialogOk={this.handleUnitModuleDialogOk}
                        onUnitModuleDialogOpen={this.handleOpenUnits}
                        onUnitModuleDialogCancel={this.handleUnitModuleDialogCancel}
                        onDefaultHandlersOk={this.handleWhistleDefaultHandlersDialogOk}
                        onDefaultHandlersOpen={this.handleOpenWhistleDefaultHandlersDialog}
                        onDefaultHandlersSave={this.handleWhistleDefaultHandlersDialogSave}
                        onDefaultHandlersCancel={this.handleWhistleDefaultHandlersDialogCancel}
                        onGetUserSelectListItems={this.handleWhistleDefaultHandlersSelectListItems}
                        onPermissionsSave={this.handlePermissionsDialogSave}
                        onPermissionsOk={this.handlePermissionsDialogOk}
                        onPermissionsOpen={this.handleOpenPermissions}
                        onPermissionsCancel={this.handlePermissionsDialogCancel}
                    />
                }
                {state.showArchiveWhistleBlowsDialog &&
                    <WhistleBlowArchiveDialog
                        companyId={state.activeCompanyId}
                        units={state.units}
                        categories={state.categories}
                        handlers={state.handlers}
                        stateFilters={state.stateFilters}
                        severityFilters={state.severityFilters}
                        resolutionFilters={state.resolutionFilters}
                        sourceFilters={state.sourceFilters}
                        anonymityFilters={state.anonymityFilters}
                        dynamicTimeFilters={state.dynamicTimeFilters}
                        onOk={this.handleArchiveWhistleBlowsDialogOk}
                        onCancel={this.handleArchiveWhistleBlowsDialogCancel}
                    />
                }
            </PageContainer>
        );
    }
}